import AnalysedCriterion from "./AnalysedCriterion";
import Alert from "../Alert";
import Treatment from "./Treatment";
import TreatmentSelectionModel from "./TreatmentSelectionModel";

export default class TreatmentSelection {
  uid: string;
  criteriaGroup: string;
  criteria: AnalysedCriterion[];
  selectedTreatments: Treatment[];
  availableTreatments: Treatment[];
  autoAssignedTreatments: Treatment[];
  alerts: Alert[];
  apiUrl?: string;

  static toModel(treatmentSelection: TreatmentSelection): TreatmentSelectionModel {
    return {
      uid: treatmentSelection.uid,
      criteriaGroup: treatmentSelection.criteriaGroup,
      criterionIds: treatmentSelection.criteria.map((c) => c.criterionId),
      selectedTreatmentIds: treatmentSelection.selectedTreatments.map((t) => t.uid),
      availableTreatmentIds: treatmentSelection.availableTreatments.map((t) => t.uid),
      autoAssignedTreatmentIds: treatmentSelection.autoAssignedTreatments.map((t) => t.uid),
      alerts: treatmentSelection.alerts,
      apiUrl: treatmentSelection.apiUrl,
    };
  }
}
